import React, { useEffect } from 'react';
import { useTheme, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import { NavigationDrawerContextProvider } from 'Views/Onboarding/Contexts/NavigationDrawerContext';
import NavigationDrawer from 'Views/Dashboard/NavigationDrawer';
import DashboardTopSectionDesktopPicker from 'Views/Dashboard/DashboardTopSectionDesktopPicker';
import CuratedContentSectionPicker from 'Views/Dashboard/CuratedContentSectionPicker';
import ActionItemsPicker from 'Views/Dashboard/ActionItemsPicker';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import HighPriorityTasksSection from 'Views/Dashboard/HighPriorityTasksSection';
import { FDHeadlineText, FDStack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { DESKTOP_TOP_PADDING, MOBILE_TOP_PADDING } from 'Components/ComponentLibrary/Molecules/PageHeader';
import useHomeContext from 'Context/HomeContext';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import { dataAttrs } from 'Helpers/Testing';
import scrollSelectorIntoView from 'Helpers/ScrollSelectorIntoView';
import { useLocation } from 'react-router';
import DesktopBalanceSheetContainer from '../../../../UI/BalanceSheetBars/Container';
import FinancialWellnessContainer from './FinancialWellness/FinancialWellnessContainer';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  airContainer: {
    width: '100%',
    backgroundColor: theme.palette.facet.lightGray,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  annualInvestmentReview: {
    margin: theme.spacing(2, 2),
  },
  heading: {
    marginTop: theme.spacing(2),
  },
});

const DigitalOnboardingDashboard = () => {
  const { clientDashboardResource } = useDashboardContext();
  const { hasLegacyDashboardImprovement } = useHomeContext();
  const isMobile = useMobileLayout();

  const location = useLocation();

  useEffect(() => {
    if (location.hash !== '') {
      scrollSelectorIntoView(location.hash);
    }
  }, [location.hash]);


  const theme = useTheme();
  const color = hasLegacyDashboardImprovement ? theme.palette.facet.lightGray : undefined;

  useBackgroundColor(color);

  return (
    <NavigationDrawerContextProvider
      onboardingNavigationLink={clientDashboardResource?.relationship(fr.relationships.onboardingNavigation.name)?.link('related')}
    >
      <Box
        test={'dashboard-root'}
      >
        <Box paddingTop={isMobile ? MOBILE_TOP_PADDING : DESKTOP_TOP_PADDING}>
          <FDStack direction="column" spacing={2} paddingY={3}>
            <FDHeadlineText value="My Dashboard" size={isMobile ? 'sm' : 'lg'} align="center" />
            <DashboardTopSectionDesktopPicker />
          </FDStack>
        </Box>
      </Box>
      <HighPriorityTasksSection />
      <section id="dashboard-action-items" {...dataAttrs('dashboard-action-items')}>
        <ActionItemsPicker />
      </section>
      <CuratedContentSectionPicker />
      <section id="dashboard-balance-sheet" test="dashboard-balance-sheet-section">
        <DesktopBalanceSheetContainer BalanceSheetTitleProps={{ weight: 'bold' }} />
      </section>
      <section id="dashboard-financial-wellness">
        <FinancialWellnessContainer TitleProps={{ weight: 'bold' }} />
      </section>
      <NavigationDrawer />
    </NavigationDrawerContextProvider>
  );
};

DigitalOnboardingDashboard.propTypes = {};

export default withStyles(styles)(DigitalOnboardingDashboard);
